export enum Disability {
    WHEELCHAIR = "wheelchair",
    BLIND = "blind",
    DEAF = "deaf",
}